// Generated by `yarn tokens:import --aos-ds` from the Figma component set "TaskDetailsCard" (14053:196055). Do not edit.

import type { FigmaGlyph } from '../../icons/glyph'

export type ContractProp =
    | { kind: 'enum'; values: readonly string[] }
    | { kind: 'boolean' }
    | { kind: 'text' }
    | { kind: 'instance_swap' }
    // A matrix can carry slots too — Modal/Footer has two.
    | { kind: 'slot' }

export type ContractComposition = { component: string; variants: readonly string[] }

// A place the Figma file contradicts itself, grouped by what it says. `count` is
// how many places say it; `property` and `stated` are set for an alignment the
// file states and does not draw.
export type ContractDisagreement = {
    note: string
    count: number
    property?: string
    stated?: string
}

export type ContractVariant = {
    container: string
    label: string
    // The surface, when the paint sits on a child rather than the root:
    // empty for every component that paints its own frame.
    box: string
    // Every named node the variant draws beyond those two, keyed by the
    // name Figma gives it. A key that reads as a value rather than a role
    // means the component is a composition, not a primitive.
    parts: Record<string, string>
    // The shape of every part that is one — a VECTOR drawn on top of
    // something the variant also paints, which the whole-variant `glyph`
    // cannot describe because that one requires no paint at all.
    glyphs: Record<string, FigmaGlyph>
    // The glyph the variant draws, inked separately from the label.
    icon: string
    // Applied in JS: `disabled:` never matches a react-native-web div, and
    // `:visited` exists only on an anchor.
    disabled: string
    visited: string
    // Which of `textStyleIds` each text part is set in. The ids are a set,
    // so a component with two says two exist and not which part uses which.
    partTextStyles: Record<string, string>
    // What this cell instantiates, and which variant of it.
    composes: readonly ContractComposition[]
}

export const taskdetailscardContract = {
    component: 'TaskDetailsCard',
    nodeId: '14053:196055',
    section: '[Web] Timelines/Task & Events',
    // Components a variant instantiates, with the variant keys used.
    // Where one of these carries the component's own paint rather than
    // a glyph, the classes below describe only what is left — Checkbox
    // swaps a whole box here.
    composes: [
        { component: 'ArrowRight', variants: [] },
        { component: 'Button', variants: ['size=small, state=default, type=text'] },
        { component: 'Delete', variants: [] },
        { component: 'DetailsListItem', variants: ['type=short'] },
        { component: 'EditWithoutBackground', variants: [] },
        { component: 'Link', variants: ['state=default'] },
        { component: 'StatusStripe', variants: ['status=neutral'] },
        { component: 'TaskStatusLabel', variants: ['variant=default'] },
    ],
    stateAxis: null,
    // Where the caller puts content. One `ReactNode` prop per name.
    slots: [] as readonly string[],
    // What the file says that its own drawing does not show.
    disagreeing: [
        { note: '3 labels with their own ink or style', count: 1 },
        { note: '4 labels with their own ink or style', count: 1 },
        { note: '5 labels with their own ink or style', count: 1 },
        {
            note: 'background/sub-surface is a background token, not an ink — not read as one',
            count: 3,
        },
        {
            note: 'background/surface is a background token, not an ink — not read as one',
            count: 4,
        },
        {
            note: 'fill on variant=firefighter-rescue-unit, stroke on TaskStatusLabel — read the parts, not the box',
            count: 1,
        },
        {
            note: 'fill on variant=FOD, stroke on TaskStatusLabel — read the parts, not the box',
            count: 1,
        },
        {
            note: 'primaryAxisAlignItems CENTER on a row that hugs — no slack to align in, so the file states an alignment it does not draw',
            count: 1,
            property: 'primaryAxisAlignItems',
            stated: 'CENTER',
        },
    ] as readonly ContractDisagreement[],
    textStyleIds: [
        'S:dc8849474e775e3c3f189ea31a5d655eca473208,',
        'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
    ],
    props: {
        variant: { kind: 'enum', values: ['FOD', 'firefighter-rescue-unit', 'shift-notes'] },
    },
    variants: {
        'variant=firefighter-rescue-unit': {
            container:
                'bg-background-surface border-l-4 border-l-graphics-grey rounded-common items-start',
            label: 'text-content-default text-left',
            icon: 'text-content-default',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                'content': 'items-start',
                'header': 'bg-background-surface px-xl py-l items-center',
                'header-content': 'gap-l items-center',
                'datetime-from': 'gap-m items-center',
                'Thu, 09.07.2026': 'text-content-default text-left',
                'DetailsListItem': 'gap-s items-center',
                'datetime-to': 'gap-m items-center',
                'Thu, 09.07.2026 2': 'text-content-default text-left',
                'DetailsListItem 2': 'gap-s items-center',
                'Reported by: John Doe': 'text-content-muted text-left',
                'body': 'bg-background-sub-surface px-xl py-l items-center',
                'details-row': 'gap-s items-center',
                'Ground handling': 'text-content-default text-left w-[14.25rem]',
                'status-labels': 'gap-m items-center',
                'APOC': 'text-content-default text-left',
                'TaskStatusLabel':
                    'border-graphics-grey border rounded-common px-s py-xs h-[1.6875rem] items-center justify-between',
                'TaskStatusLabel 2':
                    'border-graphics-grey border rounded-common px-s py-xs h-[1.6875rem] items-center justify-between',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'Thu, 09.07.2026': 'S:dc8849474e775e3c3f189ea31a5d655eca473208,',
                'Thu, 09.07.2026 2': 'S:dc8849474e775e3c3f189ea31a5d655eca473208,',
                'Reported by: John Doe': 'S:dc8849474e775e3c3f189ea31a5d655eca473208,',
                'Ground handling': 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
                'APOC': 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
            } as Record<string, string>,
            composes: [
                { component: 'ArrowRight', variants: [] },
                { component: 'DetailsListItem', variants: ['type=short'] },
                { component: 'StatusStripe', variants: ['status=neutral'] },
                { component: 'TaskStatusLabel', variants: ['variant=default'] },
            ],
        },
        'variant=FOD': {
            container:
                'bg-background-surface border-l-4 border-l-graphics-grey rounded-common items-start',
            label: 'text-content-default text-left',
            icon: 'text-content-default',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                'content': 'w-[47.8125rem] items-start',
                'header': 'bg-background-surface px-xl py-l items-center',
                'header-content': 'items-center',
                'title-block': 'pr-l w-[7.5rem] items-start',
                'Apron': 'text-content-default text-left',
                'Link': 'gap-s items-center',
                'TaskStatusLabel':
                    'border-graphics-grey border rounded-common px-s py-xs h-[1.6875rem] items-center justify-between',
                'actions': 'items-start justify-end',
                'Button':
                    'rounded-common px-m gap-xs w-[2.5rem] h-[2.5rem] items-center justify-center',
                'body': 'bg-background-sub-surface px-xl py-l h-[3.25rem] items-center',
                'Ground handling': 'text-content-default text-left',
                'footer': 'bg-background-surface px-xl py-l items-center',
                'footer-content': 'gap-l items-center',
                'Tue. 14.07.2026 01:00': 'text-content-default text-left',
                'Reported By: Other user': 'text-content-muted text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'Apron': 'S:dc8849474e775e3c3f189ea31a5d655eca473208,',
                'Ground handling': 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
                'Tue. 14.07.2026 01:00': 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
                'Reported By: Other user': 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
            } as Record<string, string>,
            composes: [
                { component: 'Button', variants: ['size=small, state=default, type=text'] },
                { component: 'EditWithoutBackground', variants: [] },
                { component: 'Link', variants: ['state=default'] },
                { component: 'StatusStripe', variants: ['status=neutral'] },
                { component: 'TaskStatusLabel', variants: ['variant=default'] },
            ],
        },
        'variant=shift-notes': {
            container: 'bg-background-sub-surface rounded-common items-start',
            label: 'text-content-default text-left',
            icon: 'text-content-default',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                'content': 'items-start',
                'header': 'bg-background-surface px-xl py-l items-center',
                'header-content': 'gap-l items-center',
                'datetime': 'gap-m items-center',
                'Thu, 09.07.2026': 'text-content-default text-left',
                'DetailsListItem': 'gap-s items-center',
                'Reported by: John Doe': 'text-content-muted text-left',
                'actions': 'gap-s items-start justify-end',
                'Button':
                    'rounded-common px-m gap-xs w-[2.5rem] h-[2.5rem] items-center justify-center',
                'Button 2':
                    'rounded-common px-m gap-xs w-[2.5rem] h-[2.5rem] items-center justify-center',
                'body': 'bg-background-sub-surface px-xl py-l items-center',
                'Ground handling': 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'Thu, 09.07.2026': 'S:dc8849474e775e3c3f189ea31a5d655eca473208,',
                'Reported by: John Doe': 'S:dc8849474e775e3c3f189ea31a5d655eca473208,',
                'Ground handling': 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
            } as Record<string, string>,
            composes: [
                { component: 'Button', variants: ['size=small, state=default, type=text'] },
                { component: 'Delete', variants: [] },
                { component: 'DetailsListItem', variants: ['type=short'] },
                { component: 'EditWithoutBackground', variants: [] },
                { component: 'StatusStripe', variants: ['status=neutral'] },
            ],
        },
    },
} as const satisfies {
    component: string
    nodeId: string
    section: string
    composes: readonly ContractComposition[]
    stateAxis: string | null
    slots: readonly string[]
    disagreeing: readonly ContractDisagreement[]
    textStyleIds: readonly string[]
    props: Record<string, ContractProp>
    variants: Record<string, ContractVariant>
}
